import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Sparkles, Zap } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';

const UpgradeModal = ({
  open, onClose, feature = 'this feature', requiredPlan = 'a higher plan', kind = 'plan', needed, balance,
}) => {
  const navigate = useNavigate();
  const outOfCredits = kind === 'credits';

  const handleUpgrade = () => {
    onClose();
    navigate('/settings?tab=billing');
  };

  const handleBuyCredits = () => {
    onClose();
    navigate('/settings?tab=billing#credit-packs');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="upgrade-modal">
        <DialogHeader>
          <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center">
            {outOfCredits ? <Zap className="h-6 w-6 text-amber-600" /> : <Sparkles className="h-6 w-6 text-amber-600" />}
          </div>
          <DialogTitle className="text-center">{outOfCredits ? 'Not enough AI credits' : 'Upgrade Required'}</DialogTitle>
          {outOfCredits ? (
            <DialogDescription className="text-center" data-testid="credits-modal-text">
              This needs <strong className="text-slate-700">{needed} credits</strong> and you have{' '}
              <strong className="text-slate-700">{balance}</strong>. Buy a credit pack (they never expire) or
              upgrade for more monthly credits. Nothing was charged.
            </DialogDescription>
          ) : (
            <DialogDescription className="text-center">
              <strong className="text-slate-700">{feature}</strong> requires {requiredPlan}.
              Upgrade your subscription to unlock this feature.
            </DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col">
          {outOfCredits && (
            <Button
              onClick={handleBuyCredits}
              className="w-full bg-emerald-500 hover:bg-emerald-600 text-white"
              data-testid="buy-credits-btn"
            >
              <Zap className="h-4 w-4 mr-2" />
              Buy Credits
            </Button>
          )}
          <Button
            variant={outOfCredits ? 'outline' : 'default'}
            onClick={handleUpgrade}
            className={outOfCredits ? 'w-full' : 'w-full bg-emerald-500 hover:bg-emerald-600 text-white'}
            data-testid="upgrade-now-btn"
          >
            <CreditCard className="h-4 w-4 mr-2" />
            {outOfCredits ? 'Upgrade Plan' : 'View Plans & Upgrade'}
          </Button>
          <Button
            variant="ghost"
            onClick={onClose}
            className="w-full"
          >
            Maybe Later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeModal;
